import React from "react";
import fieldPropTypes from "./field-prop-types";

const Bar = ({ components: { HorizontalRule } }) => <HorizontalRule />;

Bar.propTypes = fieldPropTypes;

export default Bar;
